module.exports = __webpack_public_path__ + "public/images/partner.d54c0bd63aad530a02aaf27dce11d85d.png";